export const mockData = {
  services: [
    {
      id: 1,
      title: "Dedicated export office",
      description: "We act as your Italian export office, managing all aspects of product sourcing, quality control, and logistics from Tuscany to your destination.",
      icon: "building"
    },
    {
      id: 2,
      title: "Product sourcing",
      description: "Access to the finest Italian food producers and artisans. We identify, verify, and secure authentic Italian products that match your quality standards.",
      icon: "search"
    },
    {
      id: 3,
      title: "Quality assurance",
      description: "Rigorous quality checks and certifications ensure every product meets international standards and maintains authentic Italian excellence.",
      icon: "shield-check"
    },
    {
      id: 4,
      title: "Portfolio management",
      description: "Strategic guidance to build and optimize your Italian product portfolio, from market analysis to product selection and brand positioning.",
      icon: "briefcase"
    }
  ],
  productCategories: [
    {
      id: 1,
      name: "Pasta and grains",
      description: "Artisanal pasta, rice, and specialty grains from renowned Italian producers",
      icon: "wheat",
      base: "/api/img/product-1",
      width: 1200,
      height: 675,
      href: "/categories/italian-pasta"
    },
    {
      id: 2,
      name: "Preserved foods",
      description: "Tomatoes, olives, vegetables, and other Italian preserved specialties",
      icon: "container",
      base: "/api/img/product-2",
      width: 1200,
      height: 675
    },
    {
      id: 3,
      name: "Cheese and dairy",
      description: "Traditional Italian cheeses from Parmigiano Reggiano to fresh mozzarella",
      icon: "cheese",
      base: "/api/img/product-3",
      width: 1200,
      height: 675,
      href: "/categories/italian-cheese"
    },
    {
      id: 4,
      name: "Olive oil and condiments",
      description: "Extra virgin olive oils, balsamic vinegars, and premium condiments",
      icon: "droplet",
      base: "/api/img/product-4",
      width: 1200,
      height: 675,
      href: "/categories/italian-olive-oil"
    },
    {
      id: 5,
      name: "Cured meats and salumi",
      description: "Premium Italian prosciutto, salami, and artisanal cured meats",
      icon: "beef",
      base: "/api/img/product-5",
      width: 1200,
      height: 675,
      href: "/categories/italian-cured-meats"
    },
    {
      id: 6,
      name: "Soft beverages",
      description: "Curated selection of Italian soft drinks and specialty beverages",
      icon: "cup-soda",
      base: "/api/img/product-6",
      width: 1200,
      height: 675
    }
  ],
  whyChooseUs: [
    {
      id: 1,
      title: "Local expertise",
      description: "Based in Tuscany with direct relationships to Italy's finest producers.",
      icon: "map-pin"
    },
    {
      id: 2,
      title: "Quality first",
      description: "Every product is vetted for authenticity and international compliance.",
      icon: "award"
    },
    {
      id: 3,
      title: "End-to-end service",
      description: "We manage the entire export process from sourcing to delivery.",
      icon: "truck"
    },
    {
      id: 4,
      title: "Tailored solutions",
      description: "Services customized to your specific market needs and goals.",
      icon: "target"
    }
  ]
};